import { render, staticRenderFns } from "./Instellingen.vue?vue&type=template&id=3f2bba38&"
import script from "./Instellingen.vue?vue&type=script&lang=js&"
export * from "./Instellingen.vue?vue&type=script&lang=js&"
import style0 from "./Instellingen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports